import { ObjectPool } from "./ObjectPool";
import { WINDOWSTATE } from "../../../../../common/constants";
import DockableWindow from "../../Docking/dockableWindow";

class WindowPool extends ObjectPool<DockableWindow> {
	*iterator() {
		for (const windowName in this.objects) {
			const win = this.get(windowName);
			if (
				win.win.windowState !== WINDOWSTATE.MINIMIZED_WAS_MAXIMIZED &&
				win.win.windowState !== WINDOWSTATE.MINIMIZED_WAS_NORMAL &&
				!win.isHidden
			) {
				yield win;
			}
		}
	}
}
export { WindowPool };
